jQuery(document).ready(function(){
	const configuratorElements = document.querySelectorAll('.mad-3d-configurator');
	if (!configuratorElements.length) {
		return;
	}
	console.log('3D Configurator script initializing.');

	const DEFAULT_ORIGIN = 'https://ui.pcon-solutions.com';
	const modalActiveClass = 'is-active';
	const bodyNoScrollClass = 'mad-3d-configurator--no-scroll';

	const buildArticleBlock = (article, index) => {
		if (!article || typeof article !== 'object') {
			return `Position ${index + 1}:\n===========\nInvalid article data`;
		}
		const lines = [];
		lines.push(`Position ${index + 1}:`);
		lines.push('===========');

		const addLine = (label, value) => {
			if (value === '' || value === null || value === undefined) {
				return;
			}
			lines.push(`${label}: ${value}`);
		};

		addLine('itemId', article.itemId);
		addLine('manufacturerId', article.manufacturerId);
		addLine('seriesId', article.seriesId);
		addLine('baseArticleNumber', article.baseArticleNumber);
		addLine('variantCode', article.variantCode);
		addLine('shortText', article.shortText);
		addLine('longText', article.longText);
		addLine('featureText', article.featureText);
		addLine('articleImage', article.articleImage);
		console.log(article.options);

		return lines.join('\n');
	};

	const buildConfiguratorData = (data) => {
		if (!data || !Array.isArray(data.articles)) {
			return '';
		}

		return data.articles
			.map((article, index) => buildArticleBlock(article, index))
			.join('\n\n-------------\n\n');
	};

	const setFieldValue = (formElement, selectorClass, value) => {
		if (!selectorClass) {
			return false;
		}
		const fieldContainer = formElement.querySelector(`.${selectorClass}`);
		if (!fieldContainer) {
			return false;
		}
		const fieldElement =
			fieldContainer.matches('input, textarea, select')
				? fieldContainer
				: fieldContainer.querySelector('input, textarea, select');
		if (!fieldElement) {
			return false;
		}
		fieldElement.value = value == null ? '' : String(value);
		fieldElement.dispatchEvent(new Event('input', { bubbles: true }));
		fieldElement.dispatchEvent(new Event('change', { bubbles: true }));
		return true;
	};

	const openModal = (modalElement) => {
		if (!modalElement) {
			return;
		}
		modalElement.classList.add(modalActiveClass);
		modalElement.setAttribute('aria-hidden', 'false');
		document.body.classList.add(bodyNoScrollClass);
	};

	const closeModal = (modalElement) => {
		if (!modalElement) {
			return;
		}
		modalElement.classList.remove(modalActiveClass);
		modalElement.setAttribute('aria-hidden', 'true');
		document.body.classList.remove(bodyNoScrollClass);
	};

	configuratorElements.forEach((configuratorElement) => {
		const modalElement = configuratorElement.querySelector('.mad-3d-configurator__modal');
		const closeTriggers = configuratorElement.querySelectorAll('[data-pcon-close]');
		const wpformsId = configuratorElement.getAttribute('data-wpforms-id');
		const origin = configuratorElement.getAttribute('data-pcon-origin') || DEFAULT_ORIGIN;
		const allowedOrigin = new URL(origin).origin;

		const fieldClassMap = {
			company: configuratorElement.getAttribute('data-field-class-company'),
			name: configuratorElement.getAttribute('data-field-class-name'),
			function: configuratorElement.getAttribute('data-field-class-function'),
			street: configuratorElement.getAttribute('data-field-class-street'),
			postalCity: configuratorElement.getAttribute('data-field-class-postal-city'),
			email: configuratorElement.getAttribute('data-field-class-email'),
			phone: configuratorElement.getAttribute('data-field-class-phone'),
			remarks: configuratorElement.getAttribute('data-field-class-remarks'),
			wishes: configuratorElement.getAttribute('data-field-class-wishes'),
			configData: configuratorElement.getAttribute('data-field-class-config-data'),
			obxUrl: configuratorElement.getAttribute('data-field-class-obx-url'),
			productUrl: configuratorElement.getAttribute('data-field-class-product-url'),
			pdfUrl: configuratorElement.getAttribute('data-field-class-pdf-url'),
		};

		closeTriggers.forEach((trigger) => {
			trigger.addEventListener('click', () => closeModal(modalElement));
		});

		window.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				closeModal(modalElement);
			}
		});

		window.addEventListener('message', (event) => {
			console.log('Received message:', event);
			if (event.origin !== allowedOrigin) {
				return;
			}

			const payload = event.data;
			if (!payload || typeof payload !== 'object') {
				return;
			}

			const action = payload.action || payload.type;
			if (action !== 'contact-request') {
				return;
			}

			const data = payload.data || payload;
			const formElement = wpformsId ? document.getElementById(`wpforms-form-${wpformsId}`) : null;
			if (formElement) {
				setFieldValue(formElement, fieldClassMap.configData, buildConfiguratorData(data));
				setFieldValue(formElement, fieldClassMap.obxUrl, data.obxUrl || '');
				setFieldValue(formElement, fieldClassMap.productUrl, data.reopenUrl || '');
				setFieldValue(formElement, fieldClassMap.pdfUrl, data.pdfUrl || '');
			}

			openModal(modalElement);
		});
	});
});
